import React from 'react';

interface ChatWidgetErrorBoundaryState {
  hasError: boolean;
}

export class ChatWidgetErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ChatWidgetErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ChatWidgetErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('ChatWidget error:', error);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
